import { get, put, post, axios } from './baseAxios';
import { API_CMS_USER_CONTACTS } from '../utils/urls';

const url = API_CMS_USER_CONTACTS;

export const getById = (id) => get(`${url}/${id}`);

export const filter = (params) => get(url, { params });

export const update = (id, request) => put(`${url}/${id}`, request);

export const publish = (request) => post(`${url}/published`, request);

export const create = (request) => post(url, request);

export const deleteById = (id) => axios.delete(`${url}/${id}`);

export const filterPublished = () => get(`${url}/published`);
